<template>
  <div class="sample">
    <div class="filters f--c">
      <el-select v-model="filters.clients" multiple collapse-tags size="mini" filterable placeholder="Search Clients" clearable @change="handleSearchInput" style="width:190px;flex-shrink: 0;">
        <el-option
          v-for="item in customerNames"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select v-model="filters.divisions" multiple collapse-tags size="mini" filterable placeholder="Search Division" clearable @change="handleSearchInput" style="width:190px;flex-shrink: 0;">
        <el-option
          v-for="item in departmentList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select v-model="filters.categoryList" multiple collapse-tags size="mini" filterable placeholder="Search Categories" clearable @change="handleSearchInput" style="width:190px;flex-shrink: 0;">
        <el-option
          v-for="item in categoryList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select v-model="filters.brands" multiple collapse-tags size="mini" filterable placeholder="Search Brand" clearable @change="handleSearchInput" style="width:190px;flex-shrink: 0;">
        <el-option
          v-for="item in brandList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-select v-if="[1,2].includes(activeKey)" v-model="filters.attributeStatus" multiple collapse-tags size="mini" filterable placeholder="Search Type" clearable @change="handleSearchInput" style="width:190px;flex-shrink: 0;">
        <el-option
          v-for="item in attributeStatusList"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <el-date-picker v-if="shipped" v-model="dateTime" :clearable="true" size="mini" type="daterange" range-separator="~" placement="bottom-start" value-format="timestamp" start-placeholder="Ship Date Start" end-placeholder="Ship Date End" class="el-date-picker" @change="e => changeDatePicker(e, 'shipOutDate')" style="width:280px" />
      <el-date-picker v-else v-model="dateTime" :clearable="true" type="daterange" size="mini" range-separator="~" placement="bottom-start" value-format="timestamp" start-placeholder="Received Date Start" end-placeholder="Received Date End" class="el-date-picker" @change="e => changeDatePicker(e, 'applicationDate')" style="width:290px" />
      <el-input v-model.trim="filters.searchContent" clearable size="mini" :placeholder="`${shipped?'Enter Style No. or Tracking No.':'Enter Style No.'}`" style="width: 300px;" @change="handleSearchInput">
        <el-button slot="append" icon="el-icon-search" @click="handleSearchInput"></el-button>
      </el-input>
      <div v-if="orders.length" size="mini" style="background-color: rgba(205, 212, 221, 0.22); height: 28px; width: 28px" class="f-c-c pointer" @click="allExport(2)">
        <i class="el-icon-download" style="font-size: 20px;color:#99C41C;"></i>
      </div>
    </div>
    <el-table ref="tableData" :data="orders" :key="tableKey" size="small" height="calc(100vh - 276px)" @selection-change="handleSelectionChange" stripe @sort-change="onTableSortChange" class="table" :header-cell-style="headerCellStyle">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column prop="styleNumber" label="Style No." width="150" fixed="left"></el-table-column>
      <el-table-column prop="client" label="Client" width="100" fixed="left"></el-table-column>

      <!--
        Samples sent
        Type 非TOP // shipped && !filters.attributeStatus.some(t => t === 'TOP')
      -->
      <template v-if="activeKey === 1">
        <el-table-column prop="division" label="Division" width="100" fixed="left"></el-table-column>
        <el-table-column prop="categories" label="Categories" width="100" fixed="left"></el-table-column>
        <el-table-column prop="sampleImage" label="Image" width="80" fixed="left">
          <div :key="scope.row.id" slot-scope="scope">
            <el-popover placement="right" width="280" trigger="hover" popper-class="popper-img">
              <oss-img style="width:100%" :src="scope.row.sampleImage" :width="240" mType="lfit" />
              <!-- <el-image fit="cover" :src="scope.row.sampleImage" ></el-image> -->
              <oss-img slot="reference" :src="scope.row.sampleImage" :width="48" :height="64" />
            </el-popover>
          </div>
        </el-table-column>
        <el-table-column prop="brand" label="Brand" min-width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.brand }}</div>
        </el-table-column>
        <el-table-column prop="attributeStatus" label="Type" width="150"></el-table-column>
        <el-table-column prop="fabrication" label="Fabrication" width="100"></el-table-column>
        <el-table-column prop="finishedProductWeight" label="Weight" width="100"></el-table-column>
        <el-table-column prop="ldpPrice" label="LDP($)" width="110"></el-table-column>
        <el-table-column prop="buyer" label="Buyer" min-width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.buyer }}</div>
        </el-table-column>
        <el-table-column prop="applicationDate" label="Received Date" sortable="custom" width="140">
          <template slot-scope="scope">
            {{ scope.row.applicationDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="expectedDeliveryDate" label="Est Sending Date" sortable="custom" width="160" key="expectedDeliveryDate">
          <template slot-scope="scope">
            {{ scope.row.expectedDeliveryDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="sendingDate" label="Sending Date" sortable="custom" width="130">
          <template slot-scope="scope">
            {{ scope.row.sendingDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="trackingNumber" label="Tracking No." min-width="120">
          <div slot-scope="scope" style="white-space:pre-wrap;color:#99C41C" class="pointer" @click="handleTrackingNumberClick(scope.row.trackingNumber)">{{ scope.row.trackingNumber }}</div>
        </el-table-column>
        <el-table-column prop="sampleSize" label="Size" width="60">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.sampleSize }}</div>
        </el-table-column>
        <el-table-column prop="sampleUnits" label="Units" width="60"></el-table-column>
        <el-table-column prop="bestSellersDate" label="Best Sellers Date" sortable="custom" width="160">
          <template slot-scope="scope">
            {{ scope.row.bestSellersDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="comment" label="Comment" width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.comment }}</div>
        </el-table-column>
        <el-table-column prop="remark" label="Remark" width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.remark }}</div>
        </el-table-column>
      </template>

      <!--
        Samples sent
        Type 为TOP // shipped && filters.attributeStatus.some(t => t === 'TOP')
      -->
      <template v-if="activeKey === 3">
        <el-table-column prop="customerPoId" label="PO#" width="100" fixed="left"></el-table-column>
        <el-table-column prop="sampleImage" label="Image" width="80" fixed="left">
          <div :key="scope.row.id" slot-scope="scope">
            <el-popover placement="right" width="280" trigger="hover" popper-class="popper-img">
              <oss-img style="width:100%" :src="scope.row.sampleImage" :width="240" mType="lfit" />
              <!-- <el-image fit="cover" :src="scope.row.sampleImage" ></el-image> -->
              <oss-img slot="reference" :src="scope.row.sampleImage" :width="48" :height="64" />
            </el-popover>
          </div>
        </el-table-column>
        <el-table-column prop="division" label="Division" width="100" fixed="left"></el-table-column>
        <el-table-column prop="categories" label="Categories" width="100" fixed="left"></el-table-column>
        <el-table-column prop="expectedDeliveryDate" label="Est Sending Date" sortable="custom" width="160" key="expectedDeliveryDate">
          <template slot-scope="scope">
            {{ scope.row.expectedDeliveryDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="sendingDate" label="Sending Date" sortable="custom" width="130">
          <template slot-scope="scope">
            {{ scope.row.sendingDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="trackingNumber" label="Tracking No." min-width="120">
          <div slot-scope="scope" style="white-space:pre-wrap;color:#99C41C" class="pointer" @click="handleTrackingNumberClick(scope.row.trackingNumber)">{{ scope.row.trackingNumber }}</div>
        </el-table-column>
        <el-table-column prop="fabrication" label="Fabrication" width="100"></el-table-column>
        <el-table-column prop="finishedProductWeight" label="Weight" width="100"></el-table-column>
        <el-table-column prop="ldpPrice" label="LDP($)" width="110"></el-table-column>
        <el-table-column prop="brand" label="Brand" min-width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.brand }}</div>
        </el-table-column>
        <el-table-column prop="buyer" label="Buyer" min-width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.buyer }}</div>
        </el-table-column>
        <el-table-column prop="poStartDate" label="PO Start Date" sortable="custom" width="140">
          <template slot-scope="scope">
            {{ scope.row.poStartDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="poProductionDate" label="Production Start Date" sortable="custom" width="178">
          <template slot-scope="scope">
            {{ scope.row.poProductionDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="sampleSize" label="Size" width="60">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.sampleSize }}</div>
        </el-table-column>
        <el-table-column prop="sampleUnits" label="Units" width="60"></el-table-column>
        <el-table-column prop="remark" label="Remark" width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.remark }}</div>
        </el-table-column>
      </template>

      <!--
        Samples To be Sent
        Type 非TOP // !shipped && !filters.attributeStatus.some(t => t === 'TOP')
      -->
      <template v-if="activeKey === 2">
        <el-table-column prop="division" label="Division" width="100" fixed="left"></el-table-column>
        <el-table-column prop="categories" label="Categories" width="100" fixed="left"></el-table-column>
        <el-table-column prop="sampleImage" label="Image" width="80" fixed="left">
          <div :key="scope.row.id" slot-scope="scope">
            <el-popover placement="right" width="280" trigger="hover" popper-class="popper-img">
              <oss-img style="width:100%" :src="scope.row.sampleImage" :width="240" mType="lfit" />
              <!-- <el-image fit="cover" :src="scope.row.sampleImage" ></el-image> -->
              <oss-img slot="reference" :src="scope.row.sampleImage" :width="48" :height="64" />
            </el-popover>
          </div>
        </el-table-column>
        <el-table-column prop="brand" label="Brand" min-width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.brand }}</div>
        </el-table-column>
        <el-table-column prop="attributeStatus" label="Type" width="150"></el-table-column>
        <el-table-column prop="fabrication" label="Fabrication" width="100"></el-table-column>
        <el-table-column prop="ldpPrice" label="LDP($)" width="110"></el-table-column>
        <el-table-column prop="buyer" label="Buyer" min-width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.buyer }}</div>
        </el-table-column>
        <el-table-column prop="applicationDate" label="Received Date" sortable="custom" width="140">
          <template slot-scope="scope">
            {{ scope.row.applicationDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="expectedDeliveryDate" label="Est Sending Date" sortable="custom" width="160" key="expectedDeliveryDate">
          <template slot-scope="scope">
            {{ scope.row.expectedDeliveryDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="sampleSize" label="Size" width="60">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.sampleSize }}</div>
        </el-table-column>
        <el-table-column prop="sampleUnits" label="Units" width="60"></el-table-column>
        <el-table-column prop="bestSellersDate" label="Best Sellers Date" sortable="custom" width="160">
          <template slot-scope="scope">
            {{ scope.row.bestSellersDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="Remark" width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.remark }}</div>
        </el-table-column>
      </template>

      <!--
        Samples To be Sent
        Type 为TOP // !shipped && filters.attributeStatus.some(t => t === 'TOP')
      -->
      <template v-if="activeKey === 4">
        <el-table-column prop="customerPoId" label="PO#" width="100" fixed="left"></el-table-column>
        <el-table-column prop="sampleImage" label="Image" width="80" fixed="left">
          <div :key="scope.row.id" slot-scope="scope">
            <el-popover placement="right" width="280" trigger="hover" popper-class="popper-img">
              <oss-img style="width:100%" :src="scope.row.sampleImage" :width="240" mType="lfit" />
              <!-- <el-image fit="cover" :src="scope.row.sampleImage" ></el-image> -->
              <oss-img slot="reference" :src="scope.row.sampleImage" :width="48" :height="64" />
            </el-popover>
          </div>
        </el-table-column>
        <el-table-column prop="expectedDeliveryDate" label="Est Sending Date" sortable="custom" width="160" key="expectedDeliveryDate">
          <template slot-scope="scope">
            {{ scope.row.expectedDeliveryDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="fabrication" label="Fabrication" width="100"></el-table-column>
        <el-table-column prop="ldpPrice" label="LDP($)" width="110"></el-table-column>
        <el-table-column prop="division" label="Division" width="100" fixed="left"></el-table-column>
        <el-table-column prop="categories" label="Categories" width="100" fixed="left"></el-table-column>
        <el-table-column prop="brand" label="Brand" min-width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.brand }}</div>
        </el-table-column>
        <el-table-column prop="buyer" label="Buyer" min-width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.buyer }}</div>
        </el-table-column>
        <el-table-column prop="poStartDate" label="PO Start Date" sortable="custom" width="140">
          <template slot-scope="scope">
            {{ scope.row.poStartDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="poProductionDate" label="Production Start Date" sortable="custom" width="178">
          <template slot-scope="scope">
            {{ scope.row.poProductionDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="sampleSize" label="Size" width="60">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.sampleSize }}</div>
        </el-table-column>
        <el-table-column prop="sampleUnits" label="Units" width="60"></el-table-column>
        <el-table-column prop="remark" label="Remark" width="100">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.remark }}</div>
        </el-table-column>
      </template>

      <!-- <el-table-column v-if="filters.attributeStatus.some(t => t === 'TOP')" prop="customerPoId" label="PO#" width="100" fixed="left"></el-table-column>

      <el-table-column prop="brand" label="Brand" min-width="100">
        <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.brand }}</div>
      </el-table-column>

      <el-table-column prop="attributeStatus" label="Type" width="150" fixed="left"></el-table-column>
      <template v-if="shipped">
        <el-table-column prop="shipOutDate" label="Ship Date" sortable="custom" width="110">
          <template slot-scope="scope">
            {{ scope.row.shipOutDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="bestSellersDate" label="Best Sellers Date" sortable="custom" width="160">
          <template slot-scope="scope">
            {{ scope.row.bestSellersDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="trackingNumber" label="Tracking No." min-width="120">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.trackingNumber }}</div>
        </el-table-column>
        <el-table-column prop="material" label="Material" min-width="200">
          <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.material }}</div>
        </el-table-column>
        <el-table-column prop="ldpPrice" label="LDP Price($)" width="110"></el-table-column>
      </template>
      <template v-else>
        <el-table-column prop="applicationDate" label="Application Date" sortable="custom" width="160" key="applicationDate">
          <template slot-scope="scope">
            {{ scope.row.applicationDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="bestSellersDate" label="Best Sellers Date" sortable="custom" width="160">
          <template slot-scope="scope">
            {{ scope.row.bestSellersDate | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="expectedDeliveryDate" label="Est Ship Date" sortable="custom" width="160" key="expectedDeliveryDate">
          <template slot-scope="scope">
            {{ scope.row.expectedDeliveryDate | dateFormat }}
          </template>
        </el-table-column>
      </template>
      <el-table-column prop="division" label="Division" min-width="100"></el-table-column>

      <el-table-column prop="buyer" label="Buyer" min-width="100">
        <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.buyer }}</div>
      </el-table-column>
      <el-table-column prop="samplePurpose" label="Sample Purpose" min-width="130">
        <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.samplePurpose }}</div>
      </el-table-column>
      <el-table-column prop="sampleSize" label="Size" width="60">
        <div slot-scope="scope" style="white-space:pre-wrap">{{ scope.row.sampleSize }}</div>
      </el-table-column>
      <el-table-column prop="sampleUnits" label="Units" width="60"></el-table-column> -->
    </el-table>
    <div style="text-align:right;margin-top:10px" class="bg-white">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[20, 50, 100, 200]"
        :total="total"
        :current-page.sync="filters.pageNumber"
        :page-size="filters.pageSize"
        @current-change="pageCurrentChange"
        @size-change="pageSizeChange"/>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import _ from 'lodash'
import dayjs from 'dayjs'
import bus from '@/util/bus'
import { Notification } from 'element-ui'
import { guid } from '@/util/uuid'
import moment from 'moment'

const sendingDate = [moment().subtract(2, 'months').valueOf(), moment(new Date()).valueOf()]

export default {
  props: {
    shipped: {
      type: Boolean,
      default: () => true
    },
    activeKey: {
      type: [String, Number],
      default: () => 1
    }
  },
  data() {
    return {
      dateTime: [],
      filters: {
        startSendingDate: undefined,
        endSendingDate: undefined,
        searchContent: '',
        divisions: [],
        shipped: this.shipped,
        attributeStatus: [],
        pageSize: 50,
        pageNumber: 1
      },
      customerNames: [], // 存储客户名称列表
      departmentList: [], // 部门列表
      brandList: [], // 公司列表
      attributeStatusList: [],
      categoryList: [], // 类别列表
      orders: [],
      total: 0,
      multipleSelection: [],
      tableKey: guid()
    }
  },
  filters: {
    dateFormat(value) {
      return value ? dayjs(value).format('YYYY-MM-DD') : ''
    }
  },
  watch: {
    shipped() {
      // this.tableKey = guid()
    },
    activeKey(val) {
      this.handleReset()
      this.tableKey = guid()
      this.getKeyCustomerSampleOrders()
    }
  },
  created() {
    this.getPermissionData(3)

    this.getPermissionData(1)
    this.getPermissionData(2)
    this.getPermissionData(4)
    this.getPermissionData(5)
  },
  methods: {
    handleReset() {
      this.dateTime = []
      let attributeStatus = null
      if ([3, 4].includes(this.activeKey)) {
        attributeStatus = ['TOP']
      } else {
        attributeStatus = [] // this.attributeStatusList.filter(t => t !== 'TOP') 第四次改动 张庆辉 2025.4.1
      }
      let filters = {
        startSendingDate: undefined,
        endSendingDate: undefined,
        startApplicationDate: undefined,
        endApplicationDate: undefined,
        searchContent: '',
        shipped: this.shipped,
        divisions: [],
        attributeStatus, // this.attributeStatusList.filter(t => t !== 'TOP'), // [this.attributeStatusList[0], this.attributeStatusList[1]],
        pageSize: 50,
        pageNumber: 1
      }
      if (!this.shipped) {
        filters.sortType = 'applicationDate'
        filters.sort = 'desc'
      }
      this.filters = filters
      this.$refs.tableData.store.clearSort()
    },
    getKeyCustomerSampleOrders() {
      let filters = _.cloneDeep(this.filters)
      if (!filters.attributeStatus || !filters.attributeStatus.length) {
        filters.attributeStatus = this.attributeStatusList
      }
      API.getKeyCustomerSampleOrders(filters).then(res => {
        if (res.code !== 10000) {
          return this.$message.warning(res.message)
        }
        this.orders = res.data.list
        this.total = res.data.total
        this.$nextTick(() => {
          this.$refs.tableData.doLayout()
        })
      })
    },
    changeDatePicker(date, field) {
      if (date && date.length === 2) {
        if (field === 'shipOutDate') {
          this.filters.startSendingDate = date[0]
          this.filters.endSendingDate = date[1]
        } else {
          this.filters.startApplicationDate = date[0]
          this.filters.endApplicationDate = date[1]
        }
      } else {
        this.filters.startSendingDate = undefined
        this.filters.endSendingDate = undefined
        this.filters.startApplicationDate = undefined
        this.filters.endApplicationDate = undefined
      }
      this.filters.pageNumber = 1 // 更改日期选择时重置页码为第一页
      this.getKeyCustomerSampleOrders()
    },
    handleSearchInput() {
      this.filters.pageNumber = 1 // 更改搜索内容时重置页码为第一页
      // if (!this.filters.attributeStatus.length) {
      //   let arr = this.attributeStatusList
      //   this.filters.attributeStatus = arr.filter(t => t !== 'TOP') // [arr[0], arr[1]]
      // } else if (this.filters.attributeStatus[this.filters.attributeStatus.length - 1] === 'TOP') {
      //   this.filters.attributeStatus = ['TOP']
      // } else if (this.filters.attributeStatus.some(t => t === 'TOP')) {
      //   let i = this.filters.attributeStatus.findIndex(t => t === 'TOP')
      //   this.filters.attributeStatus.splice(i, 1)
      // }
      this.getKeyCustomerSampleOrders()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    allExport() {
      const params = {
        fileType: 2,
        taskType: this.shipped ? 27 : 28
      }
      let searchParams = _.cloneDeep(this.filters)
      if (this.multipleSelection.length) {
        searchParams.ids = this.multipleSelection.map(item => item.id)
      }
      if ([3, 4].includes(this.activeKey)) {
        searchParams.attributeStatus = ['TOP']
      } else {
        searchParams.attributeStatus = searchParams.attributeStatus.length ? searchParams.attributeStatus : this.attributeStatusList
      }

      delete searchParams.pageNumber
      delete searchParams.pageSize
      params.condition = JSON.stringify(searchParams)

      this.loadingContainer = this.$loading.service({
        text: 'Produc Exporting , Please wait'
      })
      API.importExportFile(params).then((res) => {
        this.loadingContainer.close()
        this.$refs.tableData.clearSelection()
        if (res.code !== 10000) return this.$message.error(res.message)
        const h = this.$createElement
        this.notifyInstance = Notification({
          title: 'Export task creation completed',
          message: h('el-button', { style: 'margin-top:10px;padding:8px 10px 6px 10px;position: relative;left:180px', on: { click: this.favoriteExportList }}, 'View progress'),
          duration: 5000
        })
      })
    },
    favoriteExportList() {
      bus.$emit('favoriteExportList')
      this.notifyInstance.close()
    },
    pageSizeChange(pageSize) {
      this.filters.pageSize = pageSize
      this.getKeyCustomerSampleOrders()
    },
    pageCurrentChange(page) {
      this.filters.pageNumber = page
      this.getKeyCustomerSampleOrders()
    },
    /**
     * 当表格的排序条件发生变化的时候会触发该事件
     *
     * @param {Object} value 排序对象
     */
    onTableSortChange({ prop, order }) {
      if (order) {
        this.filters.sortType = prop
        this.filters.sort = order ? (order === 'ascending' ? 'asc' : 'desc') : undefined
      } else {
        this.filters.sortType = undefined
        this.filters.sort = undefined
      }
      this.getKeyCustomerSampleOrders()
    },
    getPermissionData(searchType) {
      // 调用接口获取客户名称并更新 filters.divisions
      API.getPermissionData({ searchType }).then(res => {
        if (res.code !== 10000) return this.$message.warning(res.message)
        if (searchType === 1) this.customerNames = res.data
        else if (searchType === 2) this.brandList = res.data
        else if (searchType === 3) {
          this.attributeStatusList = res.data.filter(t => t !== 'TOP')
          // this.$set(this.filters, 'attributeStatus', [res.data[0], res.data[1]])
          // this.$set(this.filters, 'attributeStatus', this.attributeStatusList)
          this.getKeyCustomerSampleOrders() // 获取列表数据
        } else if (searchType === 4) this.departmentList = res.data
        else if (searchType === 5) this.categoryList = res.data
      })
    },
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (!this.shipped && column.property === 'applicationDate') {
        if (this.filters.sortType === 'applicationDate') {
          column.order = this.filters.sort === 'desc' ? 'descending' : this.filters.sort === 'asc' ? 'ascending' : ''
        } else {
          column.order = ''
        }
      }
      if (!this.filters.sortType) column.order = ''
    },
    handleTrackingNumberClick(trackingNumber) {
      window.open('https://t.17track.net/en#nums=' + trackingNumber + '&fc=100765')
    }
  }
}
</script>

<style lang="scss" scoped>
.sample {
  .filters {
    margin-bottom: 2px;
    flex-wrap: wrap;
    >div {
      margin-right: 10px;
      margin-bottom: 6px;
    }
    /deep/ .el-input__inner {
      border-radius: unset;
    }
    /deep/ .el-select__tags .el-tag {
      max-width: 96px !important;
    }
  }
  .table {
    /deep/ .el-popover__reference-wrapper{
      img {
        width: 48px;
        height: 64px;
      }
    }
    /deep/ .cell {
      word-break: break-word;
    }
  }
}
</style>
